import * as React from 'react';
import { styled } from '@glitz/react';
import { ArrowRight } from 'webapp/components/icons';
import Image from 'webapp/components/image';
import { LEVEL_WIDTH } from 'webapp/shell/main-menu/helpers';
import { isSvenssons } from 'webapp/theme';
import Link from 'webapp/components/Link';
import { addNavigationEventToDataLayer } from 'webapp/tracking/events/main-navigation';

import type { JSX } from "react";

type PropType = {
  level: NordicNest.Api.MenuItemApiModel;
  selectedLevel?: NordicNest.Api.MenuItemApiModel;
  setSelectedLevel?: (level: NordicNest.Api.MenuItemApiModel) => void;
  setActiveLevel?: (level: number) => void;
  menu_type: string;
  menu_category: string;
};

export const MenuItem = ({
  level,
  selectedLevel,
  setSelectedLevel,
  setActiveLevel,
  menu_type,
  menu_category,
}: PropType): JSX.Element => {
  const ListItem = level.link.to ? LinkListItem : EntryWithoutLink;

  return (
    <li>
      <ListItem
        to={level.link.to}
        onClick={e => {
          if (level.childPages.length > 0) {
            e.preventDefault();
            setSelectedLevel?.(level);
            setActiveLevel?.(Number(menu_category.slice(-1)) + 1);
          } else {
            addNavigationEventToDataLayer({ menu_type: menu_type, menu_category: menu_category });
          }
        }}
        css={selectedLevel === level && !isSvenssons && selectedDecorator}
      >
        {level.icon ? (
          <IconLink>
            <Icon image={level.icon} />
            {level.link.children}
          </IconLink>
        ) : (
          level.link.children
        )}
        {level.childPages.length > 0 && <Arrow />}
      </ListItem>
    </li>
  );
};

const LinkListItem = styled(Link, {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  textDecoration: 'none',
  padding: {
    x: t => (isSvenssons ? t.sharedSpacing.xxl : t.sharedSpacing.l),
    y: t => (isSvenssons ? t.sharedSpacing.xs : t.sharedSpacing.s),
  },
  width: LEVEL_WIDTH,
  fontSize: t => t.header?.subCategoryFontSize,
  ':hover': {
    textDecoration: 'underline',
  },
});

const EntryWithoutLink = styled.button({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: 'inherit',
  border: { xy: { width: 0 } },
  backgroundColor: 'transparent',
  padding: {
    x: t => (isSvenssons ? t.sharedSpacing.xxl : t.sharedSpacing.l),
    y: t => (isSvenssons ? t.sharedSpacing.xs : t.sharedSpacing.s),
  },
  width: '100%',
  fontSize: t => t.header?.subCategoryFontSize,
  textDecoration: 'none',
  ':hover': {
    textDecoration: 'none',
  },
  ':focus-visible': {
    outline: { width: 'initial', style: 'auto', color: 'initial', offset: 1 },
  },
  ':focus': {
    outline: { width: 0 },
  },
});

const Arrow = styled(ArrowRight, {
  flexShrink: 0,
});

const selectedDecorator = styled({
  backgroundColor: t => t.header?.menuHightlightColor,
});

const Icon = styled(Image, {
  height: 18,
  width: 18,
  objectFit: 'contain',
});

const IconLink = styled.span({
  display: 'flex',
  alignItems: 'center',
  gap: t => t.sharedSpacing.xs,
});
